import { useState } from 'react';
import { KanbanColumn } from './kanban-column';
import type { KanbanBoardProps } from '@/types';


export function KanbanBoard({
  tasks,
  onTaskDrop,
  onTaskClick,
  onAddClick,
  onEditTask,
  onDeleteTask,
  onDuplicateTask,
  onAssigneeToggle,
  allowAddTask = true,
}: KanbanBoardProps) {
  const [draggingTaskId, setDraggingTaskId] = useState<number | null>(null);

  const handleDragStart = (taskId: number) => {
    setDraggingTaskId(taskId);
  };

  const handleDragEnd = () => {
    setDraggingTaskId(null);
  };
  return (
    <div className="overflow-x-auto pb-6 -mx-2 px-2">
      <div className="flex md:grid md:grid-cols-3 gap-6 min-w-[900px] md:min-w-0">
        <div className="w-[300px] md:w-auto h-full">
          <KanbanColumn
            title="To Do"
            statusKey="todo"
            tasks={tasks.todo}
            draggingTaskId={draggingTaskId}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onTaskDrop={onTaskDrop}
            onTaskClick={onTaskClick}
            onAddClick={onAddClick}
            onEditTask={onEditTask}
            onDeleteTask={onDeleteTask}
            onDuplicateTask={onDuplicateTask}
            onAssigneeToggle={onAssigneeToggle}
            allowAddTask={allowAddTask}
          />
        </div>
        <div className="w-[300px] md:w-auto h-full">
          <KanbanColumn
            title="In Progress"
            statusKey="doing"
            tasks={tasks.doing}
            draggingTaskId={draggingTaskId}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onTaskDrop={onTaskDrop}
            onTaskClick={onTaskClick}
            onAddClick={onAddClick}
            onEditTask={onEditTask}
            onDeleteTask={onDeleteTask}
            onDuplicateTask={onDuplicateTask}
            onAssigneeToggle={onAssigneeToggle}
            allowAddTask={allowAddTask}
          />
        </div>
        <div className="w-[300px] md:w-auto h-full">
          <KanbanColumn
            title="Done"
            statusKey="done"
            tasks={tasks.done}
            draggingTaskId={draggingTaskId}
            onDragStart={handleDragStart}
            onDragEnd={handleDragEnd}
            onTaskDrop={onTaskDrop}
            onTaskClick={onTaskClick}
            onAddClick={onAddClick}
            onEditTask={onEditTask}
            onDeleteTask={onDeleteTask}
            onDuplicateTask={onDuplicateTask}
            onAssigneeToggle={onAssigneeToggle}
            allowAddTask={allowAddTask}
          />
        </div>
      </div>
    </div>
  );
}
